<template>
    <div :class="{box:true, card:windowWidth>950, animate:true, cardmobile:windowWidth<=950}">
        <div class="img animate">
           <img v-lazy="{ src: props.img, loading: '../../../img/lms/loading.png'}" width="350"/>
        </div>
        <h3>{{ props.title }}</h3>
        <p>{{ props.description }}</p>
        <button class="primary-button" @click="handleRoute">Ver más</button>
    </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue'
import router from '@/router'
import useWindowWidth from '@/composables/useWindowWidth'


const props = defineProps(['title', 'description', 'img', 'route'])
const {windowWidth} = useWindowWidth()
const handleRoute = () => {
    router.push({name: props.route})
}
</script>

<style lang="scss" scoped>

* {
    overflow-y: hidden;
}
p{
    margin-bottom: 5px;
}
.img {
    margin: 0;
    padding: 0;
}
.card {
    padding-top: 0 !important;
    margin: 5px;
    width: 350px;
    min-height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #ccc;
}
.card h3 {
    margin-top: 5px;
    margin-bottom: 5px;
}

.cardmobile {
    padding-top: 0 !important;
    margin: 5px;
    width: 350px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.cardmobile h3 {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>